/**
 * @fileoverview CommonConst const
 */
'use strict';
const CommonConst = {
  /**
   * コンポーネント定義:
   * <ul>
   * <li>LOGIN
   * <li>BERTH_CATEGORY_LIST
   * </ul>

   * コンポーネント名:
   * <ul>
   * <li>URL
   * <li>PATH
   * </ul>
   * @name COMPONENT
   * @constant
   * @memberOf const.CommonConst
   */
  COMPONENT: {
    LOGIN: {
      NAME: 'LOGIN',
      URL: '#application/authentication/login',
      PATH: 'content/application/authentication/Login',
      AUTHORITY_ID: []
    },
    ACCOUNT_PROVISIONAL_REGIST: {
      NAME: 'ACCOUNT_PROVISIONAL_REGIST',
      URL: '#application/account/accountprovisionalregist',
      PATH: 'content/application/account/AccountProvisionalRegist',
      AUTHORITY_ID: []
    },
    ACCOUNT_REGIST: {
      NAME: 'ACCOUNT_REGIST',
      URL: '#application/account/accountregist',
      PATH: 'content/application/account/AccountRegist',
      AUTHORITY_ID: []
    },
    PASSWORD_REISSUE: {
      NAME: 'PASSWORD_REISSUE',
      URL: '#application/account/passwordreissue',
      PATH: 'content/application/account/PasswordReissue',
      AUTHORITY_ID: []
    },
    MESSAGE: {
      NAME: 'MESSAGE',
      URL: '#application/other/message',
      PATH: 'content/application/other/Message',
      AUTHORITY_ID: []
    },
    PORTAL_TOP: {
      NAME: 'PORTAL_TOP',
      URL: '#contractor/portal/portaltop',
      PATH: 'content/contractor/portal/PortalTop',
      AUTHORITY_ID: ['4', '5']
    },
    PORTAL_MY_PAGE: {
      NAME: 'PORTAL_MY_PAGE',
      URL: '#contractor/portal/portalmypage',
      PATH: 'content/contractor/portal/PortalMyPage',
      AUTHORITY_ID: ['4', '5']
    },
    CAR_LIST: {
      NAME: 'CAR_LIST',
      URL: '#contractor/car/carlist',
      PATH: 'content/contractor/car/CarList',
      AUTHORITY_ID: ['4']
    },
    CAR_REGIST: {
      NAME: 'CAR_REGIST',
      URL: '#contractor/car/carregist',
      PATH: 'content/contractor/car/CarRegist',
      AUTHORITY_ID: ['4', '5']
    },
    CAR_CSV_REGIST: {
      NAME: 'CAR_CSV_REGIST',
      URL: '#contractor/car/carcsvregist',
      PATH: 'content/contractor/car/CarCsvRegist',
      AUTHORITY_ID: ['4', '5']
    },
    CAR_CONFIRMATION: {
      NAME: 'CAR_CONFIRMATION',
      URL: '#contractor/car/carconfirmation',
      PATH: 'content/contractor/car/CarConfirmation',
      AUTHORITY_ID: ['4', '5']
    },
    CAR_EDIT: {
      NAME: 'CAR_EDIT',
      URL: '#contractor/car/caredit',
      PATH: 'content/contractor/car/CarEdit',
      AUTHORITY_ID: ['4', '5']
    },
    DRIVER_LIST: {
      NAME: 'DRIVER_LIST',
      URL: '#contractor/driver/driverlist',
      PATH: 'content/contractor/driver/DriverList',
      AUTHORITY_ID: ['4']
    },
    DRIVER_REGIST: {
      NAME: 'DRIVER_REGIST',
      URL: '#contractor/driver/driverregist',
      PATH: 'content/contractor/driver/DriverRegist',
      AUTHORITY_ID: ['4', '5']
    },
    DRIVER_CSV_REGIST: {
      NAME: 'DRIVER_CSV_REGIST',
      URL: '#contractor/driver/drivercsvregist',
      PATH: 'content/contractor/driver/DriverCsvRegist',
      AUTHORITY_ID: ['4', '5']
    },
    DRIVER_CONFIRMATION: {
      NAME: 'DRIVER_CONFIRMATION',
      URL: '#contractor/driver/driverconfirmation',
      PATH: 'content/contractor/driver/DriverConfirmation',
      AUTHORITY_ID: ['4', '5']
    },
    DRIVER_EDIT: {
      NAME: 'DRIVER_EDIT',
      URL: '#contractor/driver/driveredit',
      PATH: 'content/contractor/driver/DriverEdit',
      AUTHORITY_ID: ['4', '5']
    }
  },

  /**
   * ログレベル：
   * <ul>
   * <li>verbose
   * <li>debug
   * <li>info
   * <li>warning
   * <li>error
   * </ul>
   * @name LOG_LEVEL
   * @constant
   * @memberOf const.CommonConst
   */
  LOG_LEVEL: {
    verbose: 0,
    debug: 1,
    info: 2,
    warning: 3,
    error: 4
  },

  /**
   * ログレベルKey：
   * <ul>
   * <li>verbose
   * <li>debug
   * <li>info
   * <li>warning
   * <li>error
   * </ul>
   * @name LOG_LEVEL_KEY
   * @constant
   * @memberOf const.CommonConst
   */
  LOG_LEVEL_KEY: ['verbose', 'debug', 'info', 'warning', 'error'],

  /**
   * ログの最大保存件数
   * @name LOG_RECORD_MAX_COUNT
   * @constant
   * @memberOf const.CommonConst
   */
  LOG_RECORD_MAX_COUNT: 1000,

  /**
   * ストレージKey：
   * <ul>
   * <li>ログ
   * <li>権限ID
   * </ul>
   * @name STORAGE_KEY
   * @constant
   * @memberOf const.CommonConst
   */
  STORAGE_KEY: {
    LOG: 'log',
    AUTHORITY_ID: 'authorityId',
    ACCOUNT_ID: 'accountId',
    CENTER_DOMAIN: 'centerDomain',
    CENTER_ID: 'centerId',
    PORTAL_DOMAIN: 'portalDomain',
    TOKEN: 'token',
    SETTING_MEMORY: 'settingMemory',
    TO_SCREEN_NO: 'toScreenNo'
  },

  /**
   * テーマ
   * @name THEME
   * @constant
   * @memberOf const.CommonConst
   */
  THEME: 'windows',

  /**
   * タイムアウト時間
   * <ul>
   * <li>デフォルト
   * </ul>
   * @name TIMEOUT
   * @constant
   * @memberOf const.CommonConst
   */
  TIMEOUT: {
    DEFAULT: 30000
  },

  /**
   * REST API一覧
   * @name API_LIST
   * @constant
   * @memberOf const.CommonConst
   */
  API_LIST: {
    A01: '/portal/login',
    A02: '/portal/logout',
    A03: '/portal/account/preregist',
    A04: '/portal/account/regist',
    A05: '/portal/account/resetpass',
    A06: '/portal/account/edit',
    A07: '/portal/account/detail',
    A12: '/portal/home',
    A13: '/portal/driver',
    A14: '/portal/driver/regist',
    A15: '/portal/driver/edit',
    A16: '/portal/driver/delete',
    A17: '/portal/driver/detail',
    A18: '/portal/driver/outputcsv',
    A19: '/portal/driver/inputcsv',
    A20: '/portal/car',
    A21: '/portal/car/regist',
    A22: '/portal/car/edit',
    A23: '/portal/car/delete',
    A24: '/portal/car/detail',
    A25: '/portal/car/outputcsv',
    A26: '/portal/car/inputcsv',
    A91: '/portal/account/preregist',
    A99: '/portal/blob/getCsvUploadUrl',
    A120: '/portal/account/driver/detail',
    A121: '/portal/account/driver/edit/web'
  },

  /**
   * HTTPステータスコードリスト
   * <ul>
   * <li>401
   * </ul>
   * @name HTTP_STATUS_CODE_LIST
   * @constant
   * @memberOf const.CommonConst
   */
  HTTP_STATUS_CODE_LIST: {
    BAD_REQUEST: 400,
    UNAUTHORIZED: 401
  },

  /**
   * 曜日リスト
   * <ul>
   * <li>月
   * <li>火
   * <li>水
   * <li>木
   * <li>金
   * <li>土
   * <li>日
   * </ul>
   * @name WEEK_LIST
   * @constant
   * @memberOf const.CommonConst
   */
  WEEK_LIST: ['1', '2', '3', '4', '5', '6', '0'],

  /**
   * 入力値の最大文字数リスト
   * <ul>
   * <li>50
   * </ul>
   * @name INPUT_MAX_LENGTH_LIST
   * @constant
   * @memberOf const.CommonConst
   */
  INPUT_MAX_LENGTH_LIST: {
    MAX_1: 1,
    MAX_3: 3,
    MAX_4: 4,
    MAX_8: 8,
    MAX_11: 11,
    MAX_32: 32,
    MAX_50: 50,
    MAX_256: 256
  },

  /**
   * 権限リスト
   * <ul>
   * <li>システム管理者
   * <li>センター管理者
   * <li>バース作業員
   * <li>配送業者
   * <li>ドライバー
   * </ul>
   * @name TIMEOUT
   * @constant
   * @memberOf const.CommonConst
   */
  AUTHORITY_LIST: {
    SYSTEM_MANAGER: '1',
    CENTER_MANAGER: '2',
    BERTH_WORKER: '3',
    CONTRACTOR: '4',
    DRIVER: '5'
  },

  /**
   * センター遷移先画面
   * <ul>
   * <li>予約一覧
   * <li>予約日時選択
   * <li>混雑状況一覧
   * </ul>
   * @name CENTER_SCREEN
   * @constant
   * @memberOf const.CommonConst
   */
  CENTER_SCREEN: {
    REQUEST_LIST: '1',
    REQUEST_DATE_AND_TIME_SELECT: '2',
    CONGESTION_SITUATION_LIST: '3'
  },

  /**
   * 正規表現パターン
   * @name REGULAR_EXPRESSION_PATTERN
   * @constant
   * @memberOf const.CommonConst
   */
  REGULAR_EXPRESSION_PATTERN: {
    /** 半角英数字 */
    P001: /^[a-zA-Z0-9]+$/,
    /** true or false */
    P002: /true|false/,
    /** 半角数字(整数) */
    P003: /^\d*$/,
    /** 半角英数記号 */
    P004: /^[\x20-\x7e]*$/,
    /** メールアドレス */
    P005: /^[a-zA-Z0-9.!#$%&'*+\\/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
    /** 全角 */
    P007: /^[^\x20-\x7e]*$/,
    /** ひらがな */
    P008: /^[\u3040-\u309f]+$/,
    /** 電話番号 */
    P009: /^0[0-9]*$/,
    /** 分類番号 */
    P010: /^[A-Z0-9]+$/,
    /** ログインID */
    P011: /^[\x21-\x7e]*$/
  },

  /**
   * 一覧画面テーブル最大行数
   * @name LIST_TABLE_MAX_ROW
   * @constant
   * @memberOf const.CommonConst
   */
  LIST_TABLE_MAX_ROW: 10,

  /**
   * ファイル拡張子
   * @name FILE_NAME_EXTENSION
   * @constant
   * @memberOf const.CommonConst
   */
  FILE_NAME_EXTENSION: {
    CSV: 'csv'
  },

  /**
   * リクエストヘッダーキー
   * @name REQUEST_HEADER_KEYS
   * @constant
   * @memberOf const.CommonConst
   */
  REQUEST_HEADER_KEYS: {
    X_LOGIPULL_TOKEN: 'X-LogiPullToken'
  },

  /**
   * センターのトップ画面
   * @name CENTER_TOP_HASH
   * @constant
   * @memberOf const.CommonConst
   */
  CENTER_TOP_HASH: '/#center/booking/centertop',

  /**
   * キーボードイベントのキーコード
   * @name KEYBOARD_EVENT_KEY_CODE
   * @constant
   * @memberOf const.CommonConst
   */
  KEYBOARD_EVENT_KEY_CODE: {
    ENTER_KEY: 13
  },

  /**
   * クエリパラメータのキーリスト
   * @name QUERY_PARAMETER_KEY_LIST
   * @constant
   * @memberOf const.CommonConst
   */
  QUERY_PARAMETER_KEY_LIST: {
    QUESTION_MARK: '?',
    EQUAL: '=',
    AND: '&',
    PERIOD: '.'
  },

  /**
   * エラーエリアのスタイル
   * @name ERROR_AREA_STYLE
   * @constant
   * @memberOf const.CommonConst
   */
  ERROR_AREA_STYLE: {
    SUCCESS: 'success',
    INFO: 'info',
    WARNING: 'warning',
    DANGER: 'danger'
  },

  /**
   * 設定情報キーリスト
   * @name SETTING_MEMORY_KEY_LIST
   * @constant
   * @memberOf const.CommonConst
   */
  SETTING_MEMORY_KEY_LIST: {
    PLATE_NO: 'plateNumber',
    TRANSPORTER: 'transporter',
    DRIVER_NAME: 'driverName'
  },

  /**
   * 設定情報初期値
   * @name SETTING_MEMORY_DEFAULT
   * @constant
   * @memberOf const.CommonConst
   */
  SETTING_MEMORY_DEFAULT: {
    CAR_LIST: {
      plateNumber: '',
      transporter: ''
    },
    DRIVER_LIST: {
      transporter: '',
      driverName: ''
    }
  },

  /**
   * アカウント本登録結果
   * <ul>
   * <li>成功
   * <li>ユーザーID重複
   * <li>期限切れ
   * <li>仮登録データなし
   * <li>その他
   * </ul>
   * @name ACCOUNT_REGIST_RESULT
   * @constant
   * @memberOf const.CommonConst
   */
  ACCOUNT_REGIST_RESULT: {
    SUCCESS: '1',
    USER_ID_DUPLICATE: '2',
    EXPIRED: '3',
    NON_TEMPORARY_REGIST: '4',
    OTHER: '9'
  },

  /**
   * アカウント編集結果
   * <ul>
   * <li>成功
   * <li>ユーザーID重複
   * <li>旧パスワード誤り
   * <li>その他
   * </ul>
   * @name ACCOUNT_REGIST_RESULT
   * @constant
   * @memberOf const.CommonConst
   */
  ACCOUNT_EDIT_RESULT: {
    SUCCESS: '1',
    USER_ID_DUPLICATE: '2',
    OLD_PASSWORD_ERROR: '3',
    OTHER: '9'
  },

  /**
   * ドライバーアカウント状態
   * <ul>
   * <li>有効
   * <li>無効
   * </ul>
   * @name DRIVER_ACCOUNT_STATUS
   * @constant
   * @memberOf const.CommonConst
   */
  DRIVER_ACCOUNT_STATUS: {
    VALID: '0',
    INVALID: '1'
  },

  /**
   * ドライバー登録結果
   * <ul>
   * <li>運送会社が存在しない
   * <li>ユーザーID重複
   * </ul>
   * @name DRIVER_REGIST_RESULT
   * @constant
   * @memberOf const.CommonConst
   */
  DRIVER_REGIST_RESULT: {
    NOT_EXIST_TRANSPORT: 1,
    USER_ID_DUPLICATE: 2
  },

  /**
   * ユーザー仮登録情報取得結果
   * <ul>
   * <li>データが存在しない
   * <li>有効期限切れ
   * </ul>
   * @name ACCOUNT_PREREGIST_GET_RESULT
   * @constant
   * @memberOf const.CommonConst
   */
  ACCOUNT_PREREGIST_GET_RESULT: {
    NOT_EXIST_DATA: 1,
    EXPIRED: 2
  }
};
export default CommonConst;



// WEBPACK FOOTER //
// ./src/js/const/CommonConst.jsx